import React from 'react';
import styled from 'styled-components';
import { Card } from '../components/ui/Card';
import { PageContainer } from '../components/common/PageContainer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullseye, faBrain, faFileExport } from '@fortawesome/free-solid-svg-icons';

const MainContent = styled.div`
  position: relative;
  z-index: 1;
  flex: 1;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-8);
  box-sizing: border-box;
  overflow-y: visible;
  overflow-x: hidden;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;

  @media (max-width: 48rem) { /* --breakpoint-tablet */
    gap: var(--spacing-6);
  }

  @media (max-width: 30rem) { /* --breakpoint-mobile */
    gap: var(--spacing-4);
  }
`;

const PlaceholderCard = styled(Card)`
  max-width: var(--container-narrow);
  margin: 0 auto;
  text-align: center;
  gap: var(--spacing-4);
  padding: clamp(var(--spacing-8), 4vw, var(--spacing-12));
  background: linear-gradient(140deg, var(--color-surface), var(--color-surface-alt));
  border: 1px solid var(--color-border);
  box-shadow: var(--shadow-soft);
  backdrop-filter: blur(1.5rem);
`;

const Title = styled.h1`
  font-size: clamp(var(--font-size-2xl), 4vw, var(--font-size-3xl));
  font-weight: 700;
  color: var(--color-text-primary);
  margin: 0;
  letter-spacing: -0.02em;
  text-shadow: 0 var(--spacing-3) var(--spacing-10) rgba(255, 43, 43, 0.22);
`;

const Subtitle = styled.p`
  font-size: clamp(var(--font-size-sm), 1.5vw, var(--font-size-md));
  color: var(--color-text-secondary);
  margin: 0;
  line-height: var(--line-height-relaxed);
`;

const RoadmapStrip = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  gap: var(--spacing-3);
  justify-content: center;
  flex-wrap: wrap;
  padding: var(--spacing-4) var(--spacing-6);
  border-radius: var(--radius-xl);
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  box-shadow: var(--shadow-soft);
  backdrop-filter: blur(1.25rem);
  margin: 0 auto;
  max-width: var(--container-narrow);
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
`;

const RoadmapItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-2);
  padding: var(--spacing-2) var(--spacing-3);
  border-radius: var(--radius-pill);
  background: var(--color-surface-alt);
  border: 1px solid var(--color-border);
  font-size: var(--font-size-xs);
  color: var(--color-text-primary);
`;

export const Stats: React.FC = () => {
  return (
    <PageContainer>
      <MainContent>
        <PlaceholderCard>
          <Title>Stats workspace</Title>
          <Subtitle>
            Detailed team and opponent analytics are on the way. Expect frozen headers, responsive scrolling, rich filters,
            and AI-generated takeaways tailored to your matchups.
          </Subtitle>
        </PlaceholderCard>
        <RoadmapStrip>
          <RoadmapItem>
            <FontAwesomeIcon icon={faBullseye} /> Upcoming: lineup comparison mode
          </RoadmapItem>
          <RoadmapItem>
            <FontAwesomeIcon icon={faBrain} /> AI callouts for momentum swings
          </RoadmapItem>
          <RoadmapItem>
            <FontAwesomeIcon icon={faFileExport} /> Export-ready scouting packets
          </RoadmapItem>
        </RoadmapStrip>
      </MainContent>
    </PageContainer>
  );
};
